export default "__VITE_ASSET__DtfnePDo__"